var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventEmitter } from 'events';
import Dispatcher from '../../dispatcher/Dispatcher';
var CHANGE_EVENT = 'change';
var data = {};
var Store = /** @class */ (function (_super) {
    __extends(Store, _super);
    function Store() {
        var _this = _super.call(this) || this;
        _this.registerDispatcher();
        return _this;
    }
    Store.prototype.registerDispatcher = function () {
        this.dispatchToken = Dispatcher.register(function (action) {
            switch (action.type) {
                default:
                // do nothing
            }
        });
    };
    Store.prototype.emitChange = function () {
        this.emit(CHANGE_EVENT);
    };
    Store.prototype.addChangeListener = function (callback) {
        this.on(CHANGE_EVENT, callback);
    };
    Store.prototype.removeChangeListener = function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    };
    Store.prototype.updateFlags = function (flags) {
        data = __assign({}, flags);
        console.log('New feature flag store state', data);
        this.emitChange();
    };
    Store.prototype.flag = function (name) {
        return Boolean(data[name]);
    };
    return Store;
}(EventEmitter));
var FeatureFlagStore = new Store();
export default FeatureFlagStore;
